import { OrderingInitialState, SetCustomerAddressIdAction } from '@reducers/ordering/types';

export const setCustomerAddressId = (
  state: OrderingInitialState,
  action: SetCustomerAddressIdAction
): OrderingInitialState => ({
  ...state,
  customerState: {
    ...state.customerState,
    selectedCustomerAddressId: action.payload,
  },
});
